import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, latestArticles } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryName = category?.name || '分类';

  const articles = latestArticles.filter((a) => a.categorySlug === slug);
  const displayArticles = articles.length > 0 ? articles : latestArticles.slice(0, 6);

  const categoryUrl = `http://whzjzcgs.cn/category/${slug}`;

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName}专区 - 17吃瓜`,
    description: `17吃瓜${categoryName}专区，聚合全网最新最全的${categoryName}相关吃瓜资讯和黑料爆料，实时更新网红翻车与塌房事件。`,
    url: categoryUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: '17吃瓜',
      url: 'http://whzjzcgs.cn/',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://whzjzcgs.cn/' },
      { '@type': 'ListItem', position: 2, name: `${categoryName}专区`, item: categoryUrl },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
        <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20news%20background%20with%20dramatic%20red%20gradient%2C%20cyberpunk%20inspired%20atmosphere%2C%20dynamic%20light%20streaks%2C%20cinematic%20editorial%20photography%2C%20dark%20charcoal%20and%20deep%20red%20color%20palette%2C%20professional%20composition&width=1920&height=720&seq=category-hero-bg&orientation=landscape"
            alt={`17吃瓜${categoryName}专区`}
            title={`${categoryName} - 17吃瓜`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 to-background-100"></div>
          <div className="relative z-10 container-page h-full flex items-end pb-10">
            <div>
              <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-3" aria-label="面包屑导航">
                <Link to="/" className="hover:text-foreground-800 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-primary-400">{categoryName}</span>
              </nav>
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-50">
                {categoryName}专区
              </h1>
              <p className="text-secondary-500 text-sm mt-2">
                共 {displayArticles.length} 篇相关吃瓜内容
              </p>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-10 md:py-14">
          <div className="container-page">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {displayArticles.map((article, index) => (
                <article key={article.id} className="card-dark overflow-hidden group">
                  <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                    <div className="relative w-full h-[220px] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        title={`${article.title} - 17吃瓜${categoryName}`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="bg-primary-500/90 text-foreground-50 text-xs px-2 py-0.5 rounded-full">
                          {article.category}
                        </span>
                      </div>
                    </div>
                  </Link>
                  <div className="p-5 flex flex-col items-center text-center">
                    <Link to={`/article/${article.slug}`} className="cursor-pointer">
                      <h3 className="text-foreground-900 text-base font-medium leading-snug line-clamp-2 mb-3 group-hover:text-primary-400 transition-colors">
                        {article.title}
                      </h3>
                    </Link>
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-foreground-300 text-xs">
                        <i className="ri-eye-line mr-1"></i>
                        {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                      </span>
                      <span className="text-foreground-300 text-xs">
                        <i className="ri-chat-1-line mr-1"></i>
                        {article.comments >= 10000 ? `${(article.comments / 10000).toFixed(0)}万` : article.comments}
                      </span>
                    </div>
                    <Link
                      to={`/article/${article.slug}`}
                      className={`w-4/5 text-center text-sm font-medium py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                        index === 0
                          ? 'bg-primary-500 text-foreground-50 hover:bg-primary-400'
                          : 'border border-secondary-400 text-foreground-700 hover:border-foreground-600 hover:text-foreground-950'
                      }`}
                    >
                      查看详情
                    </Link>
                    <span className="text-secondary-600 text-xs mt-3">{article.time}</span>
                  </div>
                </article>
              ))}
            </div>

            <div className="flex items-center justify-center gap-2 mt-10">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-foreground-50 text-sm font-medium rounded-full cursor-pointer">1</span>
              <span className="w-9 h-9 flex items-center justify-center text-secondary-500 text-sm rounded-full cursor-pointer hover:text-foreground-800 transition-colors">2</span>
              <span className="w-9 h-9 flex items-center justify-center text-secondary-500 text-sm rounded-full cursor-pointer hover:text-foreground-800 transition-colors">3</span>
              <span className="text-secondary-600 text-sm mx-1">...</span>
              <span className="w-9 h-9 flex items-center justify-center text-secondary-500 text-sm rounded-full cursor-pointer hover:text-foreground-800 transition-colors">8</span>
              <span className="w-9 h-9 flex items-center justify-center text-secondary-500 text-sm rounded-full cursor-pointer hover:text-foreground-800 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}